module.exports = __webpack_public_path__ + "static/media/sms-followup.7e015a95.png";